import axios from 'axios';
import { notification } from 'antd';
import { getUserToken } from '../../../utils/Utils';
import {
  GET_PBL_P5,
  GET_PBL_P5_SUCCESS,
  GET_PBL_P5_FAILURE,
  GET_PBL_PROJECT_TYPES,
  GET_PBL_PROJECT_TYPES_SUCCESS,
  GET_PBL_PROJECT_TYPES_FAILURE,
  GET_PBL_PROJECTS,
  GET_PBL_PROJECTS_SUCCESS,
  GET_PBL_PROJECTS_FAILURE,
  CREATE_PBL_PROJECT,
  CREATE_PBL_PROJECT_SUCCESS,
  CREATE_PBL_PROJECT_FAILURE,
  UPDATE_PBL_PROJECT,
  UPDATE_PBL_PROJECT_SUCCESS,
  UPDATE_PBL_PROJECT_FAILURE,
  GET_PBL_PROJECTS_ID_SUCCESS,
  GET_PBL_PROJECTS_ID_FAILURE,
  GET_PBL_PROJECTS_ID,
  VALIDATE_PROJECT_AVAILABILITY,
  VALIDATE_PROJECT_AVAILABILITY_SUCCESS,
  VALIDATE_PROJECT_AVAILABILITY_FAILURE,
  GET_CLASS_COURSES,
  GET_CLASS_COURSES_SUCCESS,
  GET_CLASS_COURSES_FAILURE,
  GET_COURSE_TEACHERS,
  GET_COURSE_TEACHERS_SUCCESS,
  GET_COURSE_TEACHERS_FAILURE,
} from './types';
import { BASE_API_URL } from '../../../constants/initHttp';

const p5_url = `${BASE_API_URL}pbl-assessment/p5`;
const project_types_url = `${BASE_API_URL}pbl-assessment/project-types`;
const projects_url = `${BASE_API_URL}pbl-assessment/projects`;
const validate_project_availability_url = `${BASE_API_URL}pbl-assessment/projects/validate-project-availability`;
const class_courses_url = `${BASE_API_URL}v2/classes/courses-v2`;
const course_teachers_url = `${BASE_API_URL}v2/course-teach`;

// Get PBL P5 Assessment
export const getP5PBLAssessment = (params) => async (dispatch) => {
  dispatch({ type: GET_PBL_P5 });
  try {
    const response = await axios.get(p5_url, {
      params,
      headers: { Authorization: `Bearer ${getUserToken()}` },
    });
    dispatch({
      type: GET_PBL_P5_SUCCESS,
      payload: response.data?.data,
    });
  } catch (error) {
    dispatch({
      type: GET_PBL_P5_FAILURE,
      payload: error.message,
    });
  }
};

// Get Project Types
export const getPBLProjectTypes = (params = { page: 1, limit: 10, order_by: 'id', sortby: 'ASC' }) => async (
  dispatch
) => {
  dispatch({ type: GET_PBL_PROJECT_TYPES });
  try {
    const response = await axios.get(project_types_url, {
      params,
      headers: { Authorization: `Bearer ${getUserToken()}` },
    });
    dispatch({
      type: GET_PBL_PROJECT_TYPES_SUCCESS,
      payload: response.data?.data,
    });
  } catch (error) {
    dispatch({
      type: GET_PBL_PROJECT_TYPES_FAILURE,
      payload: error.message,
    });
  }
};

// Get Projects
export const getPBLProjects = (params = { page: 1, limit: 10, order_by: 'id', sortby: 'ASC' }) => async (dispatch) => {
  dispatch({ type: GET_PBL_PROJECTS });
  try {
    const response = await axios.get(projects_url, {
      params,
      headers: { Authorization: `Bearer ${getUserToken()}` },
    });
    dispatch({
      type: GET_PBL_PROJECTS_SUCCESS,
      payload: response.data?.data,
    });
  } catch (error) {
    dispatch({
      type: GET_PBL_PROJECTS_FAILURE,
      payload: error.message,
    });
  }
};

// Get Projects by id
export const getPBLProjectById = (id) => async (dispatch) => {
  dispatch({ type: GET_PBL_PROJECTS_ID });
  try {
    const response = await axios.get(`${projects_url}/id/${id}`, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    });
    dispatch({
      type: GET_PBL_PROJECTS_ID_SUCCESS,
      payload: response.data?.data,
    });
    return response.data?.data;
  } catch (error) {
    dispatch({
      type: GET_PBL_PROJECTS_ID_FAILURE,
      payload: error.message,
    });
  }
};

// Create Project
export const createPBLProject = (data, status) => async (dispatch) => {
  dispatch({ type: CREATE_PBL_PROJECT });
  try {
    const response = await axios.post(projects_url, data, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    });
    dispatch({
      type: CREATE_PBL_PROJECT_SUCCESS,
      payload: response.data?.data,
    });
    // if (status !== 'draft') {
    //   notification.success({
    //     message: 'Berhasil!',
    //     description: 'Berhasil Membuat Project',
    //     onClose: () => {
    //       window.location.reload();
    //     },
    //   });
    // }
    return response.data?.data;
  } catch (error) {
    dispatch({
      type: CREATE_PBL_PROJECT_FAILURE,
      payload: error.message,
    });
    if (status !== 'draft') {
      notification.error({
        message: 'Gagal!',
        description: error?.message,
      });
    }
    throw error;
  }
};

// Update Project
export const updatePBLProject = (id, data) => async (dispatch) => {
  dispatch({ type: UPDATE_PBL_PROJECT });
  try {
    const response = await axios.put(`${projects_url}/id/${id}`, data, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    });
    dispatch({
      type: UPDATE_PBL_PROJECT_SUCCESS,
      payload: response.data?.data,
    });
    // notification.success({
    //   message: 'Berhasil!',
    //   description: 'Berhasil Mengupdate Project',
    //   onClose: () => {
    //     window.location.reload();
    //   },
    // });
    return response.data?.data;
  } catch (error) {
    dispatch({
      type: UPDATE_PBL_PROJECT_FAILURE,
      payload: error.message,
    });
    notification.error({
      message: 'Gagal!',
      description: error?.message,
    });
    throw error;
  }
};

// Validate Project Availability
export const validateProjectAvailability = (data) => async (dispatch) => {
  dispatch({ type: VALIDATE_PROJECT_AVAILABILITY });
  try {
    const response = await axios.post(validate_project_availability_url, data, {
      headers: { Authorization: `Bearer ${getUserToken()}` },
    });
    dispatch({
      type: VALIDATE_PROJECT_AVAILABILITY_SUCCESS,
      payload: response.data?.data,
    });
    return response.data?.data;
  } catch (error) {
    dispatch({
      type: VALIDATE_PROJECT_AVAILABILITY_FAILURE,
      payload: error.message,
    });
    notification.error({
      message: 'Gagal!',
      description: error?.message,
    });
    throw error;
  }
};

// Get Class Courses
export const getClassCourses = (params) => async (dispatch) => {
  dispatch({ type: GET_CLASS_COURSES });
  try {
    const response = await axios.get(class_courses_url, {
      params,
      headers: { Authorization: `Bearer ${getUserToken()}` },
    });
    dispatch({
      type: GET_CLASS_COURSES_SUCCESS,
      payload: response.data?.data,
    });
  } catch (error) {
    dispatch({
      type: GET_CLASS_COURSES_FAILURE,
      payload: error.message,
    });
  }
};

// Get Course Teachers
export const getCourseTeachers = (schoolId, params = { status: 'active' }) => async (dispatch) => {
  dispatch({ type: GET_COURSE_TEACHERS });
  try {
    const response = await axios.get(`${course_teachers_url}/${schoolId}`, {
      params,
      headers: { Authorization: `Bearer ${getUserToken()}` },
    });
    dispatch({
      type: GET_COURSE_TEACHERS_SUCCESS,
      payload: response.data?.data,
    });
  } catch (error) {
    dispatch({
      type: GET_COURSE_TEACHERS_FAILURE,
      payload: error.message,
    });
  }
};
